angular.
module("dx.webapp.api").
factory("dxApiLegacyFinalGrades", function apiLegacyFinalGradesService(
	$http
) {
	"use strict";

	function finalGradesPost(finalGrade) {
		return $http.post("/exam/setfinalgrade/", finalGrade);
	}

	return {
		post: finalGradesPost,
	};
});
